import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../../_services';

class ReferralPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DistributorInfo: this.props.DistributorInfo,
            header: 'Referral',
            userdata: JSON.parse(localStorage.getItem('user')),
            wholesaler: this.props.whName
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(e) {
        $('.form-control').removeClass('errorIcon');
        try {
            if ($("#firstName").val() == "" || $("#firstName").val() == null || $("#firstName").val() == undefined || $("#lastName").val() == "" || $("#lastName").val() == null || $("#lastName").val() == undefined || $("#number").val() == "" || $("#number").val() == null || $("#number").val() == undefined || $("#email").val() == "" || $("#email").val() == null || $("#email").val() == undefined) {
                $('.Error').text('All fileds are required');
                $('.form-control').addClass('errorIcon');
            } else if (!userService.ValidateEmail($("#email").val())) {
                $('.Error').text('Enter a valid email ID');
                $('#email.form-control').addClass('errorIcon');
            } else {
                $('.Error').text('');
                this.PostReferral(this.state.userdata.wholesaler, this.state.userdata.paramsname, $("#firstName").val(), $("#lastName").val(), $("#email").val(), $("#number").val(), this.state.userdata.wholesaler_Id);
            }
            e.preventDefault();
        }
        catch (error) { }
    }

    PostReferral(whname, refer_by, first_name, last_name, email_id, mobile_no, wholesaler_Id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ whname, refer_by, first_name, last_name, email_id, mobile_no, wholesaler_Id})
    };
    return fetch(`/api/ds/disrefer`, requestOptions)
        .then(this.handleResponse)
        .then(user => {
            try {
                if (user) {
                    if (user.length>0) {
                        $('.Error').text(user[0].status_message);
                    }
                    else {
                        $('.Error').text('Whoops, something went wrong. Please try again');
                    }
                }
                else {
                    $('.Error').text('Whoops, something went wrong. Please try again');
                }
            }
            catch (error) {
                $('.Error').text('Whoops, something went wrong. Please try again');
            }
            return user;
        });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
   
    componentDidMount() {
        var rowsShown = 6;
        var maxnoshow = 4;

        // first tab
        var rowsTotal = $('#inactive_reps .flex-table').length;
        var numPages = rowsTotal / rowsShown;
        for (var i = 0; i < numPages; i++) {
            var pageNum = i + 1;
            $('.tab1 .nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
            $('.tab1 select').append('<option val="' + i + '">' + pageNum + '</option> ');
        }
        $('#inactive_reps > div.flex-table').hide();
        $('#inactive_reps > div.flex-table').slice(0, rowsShown).show();

        // second tab
        var rowsTotal2 = $('#inactive_reps2 .flex-table').length;
        var numPages2 = rowsTotal2 / rowsShown;
        for (var i = 0; i < numPages2; i++) {
            var pageNum = i + 1;
            $('.tab2 .nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
            $('.tab2 select').append('<option val="' + i + '">' + pageNum + '</option> ');
        }
        $('#inactive_reps2 .flex-table').hide();
        $('#inactive_reps2 .flex-table').slice(0, rowsShown).show();

        $('.tab1 .nav_in a:first').addClass('active');
        $('.tab2 .nav_in a:first').addClass('active');
        $('.tab1 .nav_in a').hide();
        $('.tab2 .nav_in a').hide();
        $('.tab1 .nav_in a').slice(0, maxnoshow).show();
        $('.tab2 .nav_in a').slice(0, maxnoshow).show();
        $('.tab1 .nav_in a').bind('click', function () {
            $('.tab1 .nav_in a').removeClass('active');
            $(this).addClass('active');
            var currPage = $(this).attr('rel');
            var startItem = currPage * rowsShown;
            var endItem = startItem + rowsShown;
            $('#inactive_reps .flex-table').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
            if ($(this).attr('rel') != '0') {
                $('.tab1 .nav_in a').hide();
                $(this).prev().show();
                $(this).show()
                $(this).next().show();
                $(this).next().next().show();
            }
        });
        $('.tab2 .nav_in a').bind('click', function () {
            $('.tab2 .nav_in a').removeClass('active');
            $(this).addClass('active');
            var currPage = $(this).attr('rel');
            var startItem = currPage * rowsShown;
            var endItem = startItem + rowsShown;
            $('#inactive_reps2 .flex-table').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
            if ($(this).attr('rel') != '0') {
                $('.tab2 .nav_in a').hide();
                $(this).prev().show();
                $(this).show()
                $(this).next().show();
                $(this).next().next().show();
            }
        });
        $('.tab1 .prev-pagination').click(function () {          
            if ($('.tab1 .nav_in .active').attr('rel') != '0') {
                $('.tab1 .nav_in .active').prev().addClass('active');
                $('.tab1 .nav_in .active').next().removeClass('active');
                $('.tab1 .nav_in a').hide();
                $('.tab1 .nav_in .active').prev().show();
                $('.tab1 .nav_in .active').show()
                $('.tab1 .nav_in .active').next().show();
                $('.tab1 .nav_in .active').next().next().next().show();
                let currentPage = $('.tab1 .nav_in .active').attr('rel');
                $('.tab1 .nav_in a').eq(currentPage).click();
            }           
            if ($('.tab1 .nav_in .active').attr('rel') == '0') {
                $('.tab1 .nav_in a').hide();
                $('.tab1 .nav_in .active').show()
                $('.tab1 .nav_in .active').next().show();
                $('.tab1 .nav_in .active').next().next().show();
                $('.tab1 .nav_in .active').next().next().next().show();
            }
        });
        $('.tab2 .prev-pagination').click(function () {
            if ($('.tab2 .nav_in .active').attr('rel') != '0') {
                $('.tab2 .nav_in .active').prev().addClass('active');
                $('.tab2 .nav_in .active').next().removeClass('active');
                $('.tab2 .nav_in a').hide();
                $('.tab2 .nav_in .active').prev().show();
                $('.tab2 .nav_in .active').show()
                $('.tab2 .nav_in .active').next().show();
                $('.tab2 .nav_in .active').next().next().next().show();
                let currentPage = $('.tab2 .nav_in .active').attr('rel');
                $('.tab2 .nav_in a').eq(currentPage).click();
            }
            if ($('.tab2 .nav_in .active').attr('rel') == '0') {
                $('.tab2 .nav_in a').hide();
                $('.tab2 .nav_in .active').show()
                $('.tab2 .nav_in .active').next().show();
                $('.tab2 .nav_in .active').next().next().show();
                $('.tab2 .nav_in .active').next().next().next().show();
            }
        });
        $('.tab1 .next-pagination').click(function () {
            $('.tab1 .nav_in .active').next().addClass('active');
            $('.tab1 .nav_in .active').prev().removeClass('active');
            $('.tab1 .nav_in a').hide();
            $('.tab1 .nav_in .active').prev().show();
            $('.tab1 .nav_in .active').show()
            $('.tab1 .nav_in .active').next().show();
            $('.tab1 .nav_in .active').next().next().show();     
            let currentPage = $('.tab1 .nav_in .active').attr('rel');
            $('.tab1 .nav_in a').eq(currentPage).click();            
        });
        $('.tab2 .next-pagination').click(function () {
            $('.tab2 .nav_in .active').next().addClass('active');
            $('.tab2 .nav_in .active').prev().removeClass('active');
            $('.tab2 .nav_in a').hide();
            $('.tab2 .nav_in .active').prev().show();
            $('.tab2 .nav_in .active').show()
            $('.tab2 .nav_in .active').next().show();
            $('.tab2 .nav_in .active').next().next().show();
            let currentPage = $('.tab2 .nav_in .active').attr('rel');
            $('.tab2 .nav_in a').eq(currentPage).click();
        });
        $('.tab1 .first_row').click(function () {
            $('.tab1 .nav_in a').eq(0).click();
            $('.tab1  .nav_in a').hide().removeClass('active');
            $('.tab1 .nav_in a:first-child').addClass('active').show();
            $('.tab1 .nav_in .active').next().show();
            $('.tab1 .nav_in .active').next().next().show();
            $('.tab1 .nav_in .active').next().next().next().show();
        });
        $('.tab1 .last_row').click(function () {
            $('.tab1 .nav_in a:last-child').click();
            $('.tab1 .nav_in a').hide().removeClass('active');
            $('.tab1 .nav_in a:last-child').addClass('active').show();
            $('.tab1 .nav_in .active').prev().show();
            $('.tab1 .nav_in .active').prev().prev().show();
            $('.tab1 .nav_in .active').prev().prev().prev().show();
        });
        $('.tab2 .first_row').click(function () {
            $('.tab2 .nav_in a').eq(0).click();
            $('.tab2 .nav_in a').hide().removeClass('active');
            $('.tab2 .nav_in a:first-child').addClass('active').show();
            $('.tab2 .nav_in .active').next().show();
            $('.tab2 .nav_in .active').next().next().show();
            $('.tab2 .nav_in .active').next().next().next().show();
        });
        $('.tab2 .last_row').click(function () {
            $('.tab2 .nav_in a:last-child').click();
            $('.tab2 .nav_in a').hide().removeClass('active');
            $('.tab2 .nav_in a:last-child').addClass('active').show();
            $('.tab2 .nav_in .active').prev().show();
            $('.tab2 .nav_in .active').prev().prev().show();
            $('.tab2 .nav_in .active').prev().prev().prev().show();
        });
        $('.tab1 select').change(function () {
            var getpage = $(this).val() - 1;
            $('.tab1 .nav_in a').eq(getpage).click();
        });
        $('.tab2 select').change(function () {
            var getpage = $(this).val() - 1;
            $('.tab2 .nav_in a').eq(getpage).click();
        });
    }
    
    render() {
        return (            
            <div className='popup'>
                <div className='popup_inner myinfo referral change-password'>
                    <div className='new-back'>
                    <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>
                    <div className="referralPopup">
                        <h3>Our team at {this.state.wholesaler} will reach out to this rep candidate on your behalf</h3>
                        <form>
                            <div className="form-group">
                                <label>First Name</label>
                                <input type="text" name="first-name" id="firstName" className="form-control" placeholder="John" />
                            </div>
                            <div className="form-group">
                                <label>Last Name</label>
                                <input type="text" name="last-name" id="lastName" className="form-control" placeholder="Smith" />
                            </div>
                            <div className="form-group">
                                <label>Contact Number</label>
                                <input type="text" name="number" id="number" className="form-control" placeholder="555-123-7890" />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" name="email" id="email" className="form-control" placeholder="john@smith.com" />
                            </div>
                            <div className="form-group">
                                <div className="pop-btn">
                                    <button onClick={this.handleSubmit} className="btn">Submit</button><button className="btn cancel" onClick={this.props.closePopup}>Cancel</button>
                                </div>
                            </div>
                            <div className="Error help-block"></div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReferralPopup;